import React, { useState, useEffect } from 'react'
import { connect } from 'react-redux';
import Footer from '../../components/footer/Footer';
import Header from '../../components/header/Header';
import MenuBar from '../../components/menu-bar/MenuBar';
import { Md5 } from 'md5-typescript';
import { WebApiCalls } from '../../webApiCalls/webApiCalls';
import Loader from "react-loader-spinner";
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";
import OTPInput from "../../components/OTPInput";
import {
	UpdateCartCount,
	UpdateCartAmount
} from "../../redux/actions/postActions";
import { KMTracking } from '../../components/Tracking/KMTracking';

function VerifyOtp(props) {
	const [otp, setOtp] = useState("")
	const [otp_error, setOTPError] = useState('')
	const [show_otp_error, setShowOTPError] = useState(false)
	const [mobile, setMobile] = useState('')
	const [verification_code, setVerification_code] = useState('')
	const [is_loading, setIsLoading] = useState(false)
	const [onEmpty, setOnEmpty] = useState(false)

	useEffect(() => {
		let veriCode = props?.location?.state?.verification_code
		let _mobile = props?.location?.state?.mobile
		// if (veriCode) {
			setVerification_code(veriCode);
			setMobile(_mobile)
		// }
		// else{
		// 	props?.history?.goBack()
		// }
	}, [])
	useEffect(() => {
        const listener = event => {
          if (event.code === "Enter" || event.code === "NumpadEnter") {
            event.preventDefault();
			verifyMobileOtp(); 
          }
        };
        document.addEventListener("keydown", listener);
        return () => {
          document.removeEventListener("keydown", listener);
        };
      }, [otp]);
	const tracker = async (eventName, _kmprops) => {
		await KMTracking(eventName, _kmprops)
	}
	const resendVerificationCode = () => {
		setOnEmpty(true);
		setOtp('')
		let c = verification_code + "#frasers"
		let checksum = Md5.init(c)
		new WebApiCalls().ResendMobileOTP(verification_code, checksum).then(response => {
			if (response && response.data) {
				setShowOTPError(true)
				setOTPError('We have sent you an OTP again. Please check your mobile')
				setOnEmpty(false)
			} else if (!response?.data && response.error) {
				setShowOTPError(true)
				setOnEmpty(false)
				setOTPError('Invalid OTP')
			}
		}).catch((error) => {
			setOnEmpty(false)
			console.log('Error catch: ', error)
		})
	}
	const verifyMobileOtp = () => {
		setIsLoading(true)
		let c = verification_code + otp + "#frasers"
		let checksum = Md5.init(c)
		if (!otp || otp.length < 6) {
			setShowOTPError(true)
			setOTPError('Please enter OTP')
			setIsLoading(false)

			return
		}
		new WebApiCalls().VerifyMobileOTP(verification_code, checksum, otp).then(response => {
			if (response && response?.data?.status == "success") {
				if(props?.location?.state?.from == 'signup'){
					let eventData = {
						contact: props?.location?.state.mobile,
						step: 'Registered OTP',
						'Current Page': 'Registration OTP',
						'Source Page': 'Registration Mobile'
					}
					tracker("pageViewed", eventData)
					props?.history?.push("/complete-profile", {
						mobile
					})
				}
				else{
					props?.history?.push("/new-pw", {
						verification_code
					})
				}
				
				setIsLoading(false)

			} else if (!response?.data && response.error) {
				setShowOTPError(true)
				setOTPError('Invalid OTP')
				setIsLoading(false)

			}
		}).catch((error) => {
			console.log('Error catch: ', error)
			setIsLoading(false)

		})
	}
	const onChange = (otp) => {
		setShowOTPError(false)
		setOtp(otp)
	}
	const ErrorView = (_text) => {
		return (<div className="error" style={{ display: "block", marginTop: 10 }}>{_text}</div>)
	}
	return (
		<div>
			<div className="viewport"></div>
			<div className="container">
				<Header props={props} />
				<MenuBar props={props} categoriesArray={props?.allCategories ? props?.allCategories : []}/>
				<div className="login">
					<div className="title">Verify Mobile No.</div>
					<div className="subtitle">An OTP has been sent to <strong>{mobile}</strong>. Please enter below.</div>
					<OTPInput
						autoFocus
						length={6}
						onEmpty={onEmpty}
						className="six-digits otp-field-wrap"
						inputClassName="otp-field"
						onChangeOTP={onChange}
					/>
					{
						show_otp_error
						&&
						ErrorView(otp_error)
					}

					<div className="loadingBlackButton" id="verifyBtn" style={{ marginTop: 25, marginBottom: 25 }}
						onClick={(event) => {
							event.preventDefault()
							verifyMobileOtp();
						}}>
						{
							is_loading ?
								<Loader
									type="TailSpin"
									color="white"
									height={18}
									width={18}
								/>
								:
								"VERIFY"}
					</div>
					<div className="join" onClick={() => {
						if (verification_code)
							resendVerificationCode();
					}}>
						<a>Resend OTP</a>
					</div>

				</div>
			</div>
			<Footer categoriesArray={props?.allCategories ? props?.allCategories : []}/>
		</div>
	)
}
const mapStateToProps = (state) => {
	const { cart_count,allCategories } = state.UserReducer
	return { cart_count,allCategories }
};
const actions = {
	UpdateCartCount,
	UpdateCartAmount
};
export default connect(mapStateToProps, actions)(VerifyOtp);